import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

const AnswerSchema = z.object({
  id: z.string(),
  text: z.string(),
  imageSrc: z.string()
});

const QuestionSchema = z.object({
  id: z.string(),
  text: z.string(),
  pinned: z.boolean(),
  image: z.object({
    src: z.string(),
    alt: z.string()
  }),
  audio: z.object({
    src: z.string(),
    transcript: z.string()
  }),
  answer1: AnswerSchema,
  answer2: AnswerSchema
});

export const YesNoQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.YesNoQuestion).extend({
  answers: z.array(QuestionSchema),
  chosenQuestionsCount: z.number(),
  gameTitle: z.string(),
  instructions: z.string(),
  questionBankCount: z.number(),
  randomizeQuestion: z.boolean(),
  saveAnswers: z.boolean(),
  showAnswerOverview: z.boolean(),
  showStars: z.boolean(),
  showSummary: z.boolean(),
  timerMinutes: z.number(),
  timerSeconds: z.number(),
  withBackgroundMusic: z.boolean(),
  withSoundEffects: z.boolean(),
  withTimer: z.boolean()
});

export type YesNoQuestionWidgetStaticSchemaType = z.infer<typeof YesNoQuestionWidgetStaticSchema>;
